import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { getLocale2 } from '../../helpers/dates';
import './specialEventsTable.css';

const SpecialEventsTable = ({ events, language, onToggleSoldOut }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'screens.soldOut.specialEvents' });
  const locale = getLocale2(language);

  return (
    <div className='se-table-container'>
      <table className='se-table'>
        <thead>
          <tr className='se-table-header'>
            <th className='se-th'>{t('columns.event')}</th>
            <th className='se-th'>{t('columns.startDate')}</th>
            <th className='se-th se-th-center'>{t('columns.status')}</th>
            <th className='se-th se-th-center'>{t('columns.action')}</th>
          </tr>
        </thead>
        <tbody>
          {(!events || events.length === 0) ? (
            <tr className='se-table-row'>
              <td className='se-td' colSpan={4} style={{ textAlign: 'center', color: 'var(--color-secondary)' }}>
                {t('noEvents')}
              </td>
            </tr>
          ) : events.map((event) => (
            <tr
              key={event.eventId}
              className={`se-table-row ${event.soldOut ? 'se-row-soldout' : ''}`}
            >
              <td className='se-td'>
                <div className='se-event-cell'>
                  <div className='se-event-image'>
                    {event.imageUrl ? (
                      <img src={event.imageUrl} alt={event.eventName} />
                    ) : null}
                  </div>
                  <span className='se-event-name'>
                    {event.eventName}
                  </span>
                </div>
              </td>
              <td className='se-td'>
                <div className='se-date-cell'>
                  <div className='se-date-badge'>
                    <span className='se-date-month'>
                      {format(new Date(event.startDate), 'MMM', { locale })}
                    </span>
                    <span className='se-date-day'>
                      {format(new Date(event.startDate), 'dd', { locale })}
                    </span>
                  </div>
                  <div className='se-date-info'>
                    <span className='se-date-time'>
                      {format(new Date(event.startDate), 'h:mm a', { locale })}
                    </span>
                    <span className='se-date-weekday'>
                      {format(new Date(event.startDate), 'EEEE', { locale })}
                    </span>
                  </div>
                </div>
              </td>
              <td className='se-td se-td-center'>
                <span className={`se-status-chip ${event.soldOut ? 'se-chip-soldout' : 'se-chip-available'}`}>
                  <span className='se-chip-dot' />
                  {event.soldOut ? t('soldOut') : t('available')}
                </span>
              </td>
              <td className='se-td se-td-center'>
                <button
                  type='button'
                  className={`se-switch ${event.soldOut ? 'se-switch-on' : ''}`}
                  onClick={() => onToggleSoldOut(event)}
                >
                  <span className='se-switch-knob' />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SpecialEventsTable;
